<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import RadioButton from '../../components/RadioButton.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'SurveyQ11OptrRating',
  components: {
    RadioButton,
    Button: SolutoButton
  },
  data () {
    return {
      data: [
        { text: this.$t('satisfied_rating_5'), key: '5' },
        { text: this.$t('somewhat_satisfied_rating_4'), key: '4' },
        { text: this.$t('neither_rating_3'), key: '3' },
        { text: this.$t('somewhat_dissatisfied_rating_2'), key: '2' },
        { text: this.$t('dissatisfied_rating_1'), key: '1' }
      ]
    };
  },
  computed: {
    ...mapGetters(['operatorRating'])
  },
  methods: {
    ...mapActions(['changeOperatorRating']),

    change (event: number) {
      this.changeOperatorRating(Number(event));
    },
    nextScreen () {
      // navigate user to Q6 which is Q12 in e-confluence page for call survey
      router.push({ path: '/survey/question6/' });
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q1">
      <p class="with-margin">{{ $t('survey_11_optr_rating_call') }}</p>
      <radio-button :text="data" @change="change($event)" :value="operatorRating.toString()"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="!operatorRating"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
